<template>
  <div style="height: 100%">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span style="color: #4a90e2">
            <i class="el-icon-location"></i>
            {{ $t('account.首页') }}
          </span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('account.设备激活') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="container" style="width: 100%; height: 90%">
      <div class="zl-content account">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('account.激活码激活')" name="1">
            <div class="zl-form">
              <div class="form-item">
                <input type="text" v-model="equipno" :placeholder="$t('account.设备编号')" />
              </div>
              <div class="form-item">
                <input type="text" v-model="cdkey" :placeholder="$t('account.激活码')" />
              </div>
              <!-- <div class="form-item">
            <input class="inputValidat" type="text" placeholder="验证码">
            <button @click="getCode(formData)" class="code-btn" :disabled="!show">
            <span v-show="show">获取验证码</span>
            <span v-show="!show" class="count">{{count}} s</span>
          </button>
          </div> -->
              <div class="form-item">
                <button class="zl-submit" type="button" @click="submit">{{ $t('account.激活账号') }}</button>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('account.批量激活')" name="2">
            <div class="zl-form">
              <el-upload
                class="upload-demo"
                action="/"
                ref="file"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-preview="handlePreview"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" style="width: 280px; height: 42px" type="primary">{{ $t('account.选择文件') }}</el-button>
              </el-upload>
              <div class="form-item">
                <button class="zl-submit" type="button" style="margin-top: 40px" @click="upload">{{ $t('account.开始上传') }}</button>
              </div>
              <div class="form-item">
                <a href="static/设备激活信息导入模板.xlsx">{{ $t('account.下载导入模板') }}</a>
              </div>
              <div v-if="message && message.length">
                {{ $t('account.信息提示') }}
                <div v-for="m in message" :key="m">{{ m }}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
const TIME_COUNT = 5
import mixin from '../utils'
import { activeequip, sendcode, fileUpload } from '../service/getData'
let loading
export default {
  name: 'app',
  mixins: [mixin],
  data() {
    return {
      // tabs = 1
      file: null,
      activeName: '1',
      // 激活文件上传
      fileList: [],
      selected: 1,
      showSetMask: false,
      formData: {
        phone: '',
        code: '',
      },

      show: true,
      count: '',
      timer: null,

      equipno: null,
      cdkey: null,
      message: null,
    }
  },
  methods: {
    upload() {
      loading = this.$loading()
      this.$refs.file.submit()
    },
    async beforeUpload(file) {
      if (!file) {
        loading.close()
        return false
      }
      this.file = file

      let formData = new FormData()
      formData.append('equipsFile', this.file)
      let res = await fileUpload(formData)
      this.$message(res.data.Message)
      this.message = res.data.AppendData
      this.$refs.file.clearFiles()
      this.file = null
      loading.close()
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `${this.$t('account.当前限制选择1个文件')}
          ${files.length}
          ${this.$t('account.个文件')}
          ${files.length + fileList.length}
          ${this.$t('account.个文件')}`
      )
    },
    async getCode() {
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)

        let result = await sendcode()
        let data = result.data
        alert(JSON.stringify(data))
      }
    },
    async submit() {
      let result = await activeequip(this.equipno, this.cdkey)
      let data = result.data
      if (data.ResultType === 0) {
        this.equipno = ''
        this.cdkey = ''
        // this.equip.usernm = ''
        // this.equip.phone = ''
        this.$message({
          message: data.Message,
          type: 'success',
        })
        this.dialogFormVisible = false
      } else {
        this.$message({
          message: data.Message,
          type: 'error',
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.zl-content {
  &.account {
    background: white;
    padding: 15px;
    .zl-form {
      width: 90%;
      margin: 0 auto;
      margin-top: 30px;
      text-align: center;
      .form-item {
        margin-bottom: 30px;
        input {
          border: 1px solid #f1f1f1;
          padding: 15px;
          width: 80%;
          &.inputValidat {
            width: 40%;
          }
        }
        button {
          border: 1px solid #f1f1f1;
          padding: 15px;
          width: 39%;
          background: rgba(0, 0, 0, 0.1);
        }
        .zl-submit {
          /* Rectangle 2: */
          background: #126c99;
          border-radius: 4px;
          color: white;
          width: 280px;
        }
      }
    }
  }
}
</style>
